import { render } from "./BaseLinkProcedureStep.vue?vue&type=template&id=07adf09a&scoped=true"
import script from "./BaseLinkProcedureStep.vue?vue&type=script&lang=js"
export * from "./BaseLinkProcedureStep.vue?vue&type=script&lang=js"

import "./BaseLinkProcedureStep.vue?vue&type=style&index=0&id=07adf09a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07adf09a"]])

export default __exports__